module.exports = __webpack_public_path__ + "static/media/short_notification.d25337a2.mp3";